export default "__VITE_ASSET__9efe3e90__"